import { CategoryData } from '../../../../types/types';

export const nombres: CategoryData = {
    // Nombres de base (1-10)
    'Moko (Un)': {
        translation: 'Un',
        translationEn: 'One',
        illustration: '1️⃣',
        audio: 'Li-moko'
    },
    'Mibale (Deux)': {
        translation: 'Deux',
        translationEn: 'Two',
        illustration: '2️⃣',
        audio: 'Li-mibale'
    },
    'Misato (Trois)': {
        translation: 'Trois',
        translationEn: 'Three',
        illustration: '3️⃣',
        audio: 'Li-misato'
    },
    'Minei (Quatre)': {
        translation: 'Quatre',
        translationEn: 'Four',
        illustration: '4️⃣',
        audio: 'Li-minei'
    },
    'Mitano (Cinq)': {
        translation: 'Cinq',
        translationEn: 'Five',
        illustration: '5️⃣',
        audio: 'Li-mitano'
    },
    'Motoba (Six)': {
        translation: 'Six',
        translationEn: 'Six',
        illustration: '6️⃣',
        audio: 'Li-motoba'
    },
    'Sambo (Sept)': {
        translation: 'Sept',
        translationEn: 'Seven',
        illustration: '7️⃣',
        audio: 'Li-sambo'
    },
    'Mwambe (Huit)': {
        translation: 'Huit',
        translationEn: 'Eight',
        illustration: '8️⃣',
        audio: 'Li-mwambe'
    },
    'Libwa (Neuf)': {
        translation: 'Neuf',
        translationEn: 'Nine',
        illustration: '9️⃣',
        audio: 'Li-libwa'
    },
    'Zomi (Dix)': {
        translation: 'Dix',
        translationEn: 'Ten',
        illustration: '🔟',
        audio: 'Li-zomi'
    },

    // Nombres de 11 à 19
    'Zomi na moko (Onze)': {
        translation: 'Onze',
        translationEn: 'Eleven',
        illustration: '1️⃣1️⃣',
        audio: 'Li-zomi_na_moko'
    },
    'Zomi na mibale (Douze)': {
        translation: 'Douze',
        translationEn: 'Twelve',
        illustration: '1️⃣2️⃣',
        audio: 'Li-zomi_na_mibale'
    },
    'Zomi na misato (Treize)': {
        translation: 'Treize',
        translationEn: 'Thirteen',
        illustration: '1️⃣3️⃣',
        audio: 'Li-zomi_na_misato'
    },
    'Zomi na minei (Quatorze)': {
        translation: 'Quatorze',
        translationEn: 'Fourteen',
        illustration: '1️⃣4️⃣',
        audio: 'Li-zomi_na_minei'
    },
    'Zomi na mitano (Quinze)': {
        translation: 'Quinze',
        translationEn: 'Fifteen',
        illustration: '1️⃣5️⃣',
        audio: 'Li-zomi_na_mitano'
    },
    'Zomi na motoba (Seize)': {
        translation: 'Seize',
        translationEn: 'Sixteen',
        illustration: '1️⃣6️⃣',
        audio: 'Li-zomi_na_motoba'
    },
    'Zomi na sambo (Dix-sept)': {
        translation: 'Dix-sept',
        translationEn: 'Seventeen',
        illustration: '1️⃣7️⃣',
        audio: 'Li-zomi_na_sambo'
    },
    'Zomi na mwambe (Dix-huit)': {
        translation: 'Dix-huit',
        translationEn: 'Eighteen',
        illustration: '1️⃣8️⃣',
        audio: 'Li-zomi_na_mwambe'
    },
    'Zomi na libwa (Dix-neuf)': {
        translation: 'Dix-neuf',
        translationEn: 'Nineteen',
        illustration: '1️⃣9️⃣',
        audio: 'Li-zomi_na_libwa'
    },

    // Vingt
    'Ntuku mibale (Vingt)': {
        translation: 'Vingt',
        translationEn: 'Twenty',
        illustration: '2️⃣0️⃣',
        audio: 'Li-ntuku_mibale'
    },

    // Dizaines
    'Ntuku misato (Trente)': {
        translation: 'Trente',
        translationEn: 'Thirty',
        illustration: '3️⃣0️⃣',
        audio: 'Li-ntuku_misato'
    },
    'Ntuku minei (Quarante)': {
        translation: 'Quarante',
        translationEn: 'Forty',
        illustration: '4️⃣0️⃣',
        audio: 'Li-ntuku_minei'
    },
    'Ntuku mitano (Cinquante)': {
        translation: 'Cinquante',
        translationEn: 'Fifty',
        illustration: '5️⃣0️⃣',
        audio: 'Li-ntuku_mitano'
    },
    'Ntuku motoba (Soixante)': {
        translation: 'Soixante',
        translationEn: 'Sixty',
        illustration: '6️⃣0️⃣',
        audio: 'Li-ntuku_motoba'
    },
    'Ntuku sambo (Soixante-dix)': {
        translation: 'Soixante-dix',
        translationEn: 'Seventy',
        illustration: '7️⃣0️⃣',
        audio: 'Li-ntuku_sambo'
    },
    'Ntuku mwambe (Quatre-vingts)': {
        translation: 'Quatre-vingts',
        translationEn: 'Eighty',
        illustration: '8️⃣0️⃣',
        audio: 'Li-ntuku_mwambe'
    },
    'Ntuku libwa (Quatre-vingt-dix)': {
        translation: 'Quatre-vingt-dix',
        translationEn: 'Ninety',
        illustration: '9️⃣0️⃣',
        audio: 'Li-ntuku_libwa'
    },

    // Centaines
    'Nkama moko (Cent)': {
        translation: 'Cent',
        translationEn: 'One hundred',
        illustration: '💯',
        audio: 'Li-nkama_moko'
    },
    'Nkama mibale (Deux cents)': {
        translation: 'Deux cents',
        translationEn: 'Two hundred',
        illustration: '2️⃣0️⃣0️⃣',
        audio: 'Li-nkama_mibale'
    },
    'Nkama mitano (Cinq cents)': {
        translation: 'Cinq cents',
        translationEn: 'Five hundred',
        illustration: '5️⃣0️⃣0️⃣',
        audio: 'Li-nkama_mitano'
    },

    // Milliers
    'Nkoto (Mille)': {
        translation: 'Mille',
        translationEn: 'One thousand',
        illustration: '1️⃣0️⃣0️⃣0️⃣',
        audio: 'Li-nkoto'
    }
};

export default nombres;
